import styled from 'styled-components';

/**
 * This is the surface of the ContextualDrawer into which all of the ContextualDrawer
 * content is rendered.
 */
const DrawerSurface = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40021409__sc-15lfm6x-0"
})(["background-color:", ";border-radius:0;box-shadow:", ";box-sizing:border-box;word-wrap:break-word;bottom:0;left:0;right:0;overflow:hidden;outline:none;padding-inline-start:", ";padding-inline-end:", ";padding-block-start:", ";padding-block-end:", ";position:fixed;max-width:100vw;@media (prefers-reduced-motion:no-preference){transition:opacity 150ms ease-in-out,transform 150ms ease-in-out;}opacity:", ";transform:", ";z-index:", ";"], ({
  theme
}) => theme.contextualDrawer.backgroundColor, ({
  theme
}) => theme.contextualDrawer.shadow, ({
  theme
}) => theme.spacing.small.mobile, ({
  theme
}) => theme.spacing.small.mobile, ({
  theme
}) => theme.spacing.small.mobile, ({
  theme
}) => theme.spacing.small.mobile, ({
  slideState
}) => {
  var _entering$entered$exi;
  return (_entering$entered$exi = {
    entering: 0,
    entered: 1,
    exiting: 0,
    exited: 0,
    unmounted: 0
  }[slideState]) !== null && _entering$entered$exi !== void 0 ? _entering$entered$exi : 0;
}, ({
  slideState
}) => ({
  entering: 'translateY(100%)',
  entered: 'translateY(0%)',
  exiting: 'translateY(100%)',
  exited: 'translateY(0%)',
  unmounted: 'none'
})[slideState], ({
  theme
}) => theme.elevation.zIndex.layer4);
DrawerSurface.displayName = 'Surface';

export { DrawerSurface as D };
//# sourceMappingURL=DrawerSurface-BPuuzZIf.js.map
